import type { ReactNode } from 'react';

import { Button } from '../button/button';
import { Modal } from '../modal/modal';

export interface DocumentUploaderModalProps {
  handleClearCancel: () => void;
  handleClearConfirm: () => void;
  showModal: boolean;
  title: ReactNode;
  cancelText: ReactNode;
  closeText: ReactNode;
  confirmText: ReactNode;
}

export const DocumentUploaderModal = ({
  handleClearCancel,
  handleClearConfirm,
  showModal,
  title,
  cancelText,
  closeText,
  confirmText,
}: DocumentUploaderModalProps) => (
  <Modal
    open={showModal}
    onClose={handleClearCancel}
    closeDialogText={closeText}
    dismissable
  >
    <Modal.Title>{title}</Modal.Title>
    <Modal.Actions>
      <Button onClick={handleClearConfirm}>{confirmText}</Button>
      <Modal.CloseButton>{cancelText}</Modal.CloseButton>
    </Modal.Actions>
  </Modal>
);
